<template>
  <div class="app-agreement">
    <div class="content">
      <p class="MsoBodyText">
        <b> </b>
      </p>
      <p class="MsoNormal" style="vertical-align: baseline">
        <b> </b>
      </p>
      <p class="p" style="vertical-align: baseline">
        <b><b> </b></b>
      </p>
      <p class="p" style="vertical-align: baseline">
        <b><b> </b></b>
      </p>
      <p class="p" style="vertical-align: baseline">
        <b><b><b> </b></b></b>
      </p>
      <p class="p" style="vertical-align: baseline"></p>
      <div class="Section0">
        <p class="MsoBodyText" style="margin-left: 0pt">
          <br />
        </p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoNormal" align="center" style="text-align: center">
          <b>分佣推广模块（分销客）</b><b>入驻协议</b><b></b>
        </p>
        <p class="MsoBodyText" style="margin-left: 0pt">
          <b>&nbsp;</b>
        </p>
        <h1 align="right" style="margin-left: 0pt; text-align: right">
          &nbsp;
        </h1>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText">一．声明与承诺</p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="17" align="justify" style="margin-left: 5pt; text-indent: 0pt; text-align: justify">
          1.1&nbsp;你在点击同意本协议之前，应当认真阅读本协议。请你务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款、法律适用和争议解决条款。免除或者限制责任的条款将以粗体下划线标识，你应重点阅读。如你对协议有任何疑问，可向供给互联客服咨询。
        </p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="17" style="margin-left: 18.55pt; text-indent: -13.55pt">
          1.2&nbsp;&nbsp;当你勾选本协议后，即表示你已充分阅读、理解并接受本协议的全部内容，并与供给互联就协议内容达成一致。阅读本协议的过程中
        </p>
        <p class="MsoBodyText">
          ，如果你不同意本协议或其中任何条款约定或无法准确理解条款的含义及解释，请不要进行后续操作。
        </p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <h1>&nbsp;</h1>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText">二．定义</p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText">
          2.1 商家：指使用本服务的“供给云”<span>商家，本协议中称</span><span>“你”或商家。</span>
        </p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText">
          2.2 分销客：指使用“供给云”平台为商家提供推广服务的单位或个人。
        </p>
        <p class="MsoBodyText" style="margin-left: 0pt">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </p>
        <p class="MsoBodyText" style="margin-left: 0pt">
          三、协议的生效与变更
        </p>
        <p class="MsoBodyText">3.1 签约主体</p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText">
          3.1.1 本协议由你与<u><span style="color: #f00"><span style="color: #f00">北京供给互联网有限公司</span></span></u><span>（以下简称</span><span>“</span><u><span style="color: #f00"><span style="color: #f00">供给互联</span></span></u>”）共同缔结。
        </p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText">3.1.2</p>
        <p class="MsoBodyText">
          你确认你是具有法律规定的完全民事权利能力和民事行为能力、能够独立承担民事责任的自然人、法人或其他组织；本协议内容不受你所属国家或地区的排斥。
        </p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText">
          3.1.3&nbsp;<u><span style="color: #f00"><span style="color: #f00">供给互联</span></span></u>有权根据服务或者运营需求，单方面安排或指定其关联公司、控股公司或<u><span style="color: #f00"><span style="color: #f00">供给互联</span></span></u>认可的第三方公司提供部分或全部的相关服务。<u><span style="color: #f00"><span style="color: #f00">供给互联</span></span></u>有权单方面根据业务或运营需求将本协议相关权利义务部分或全部转让给第三方，转让后由受让方与你共同履行本协议。
        </p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText">3.2 协议的补充及变更</p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="17" style="margin-left: 5pt; text-indent: 0pt">
          3.2.1&nbsp;&nbsp;<span style="color: #f00">供给互联</span>可基于国家法律法规变化、业务调整、产品更新及维护交易秩序、保护消费者权益等需要对协议内容进行变更，变更后的协议将按照法定程序进行公示并在<span style="color: #f00">官方网站公告</span>。如你不同意变更内容，你有权于变更内容确定的生效日前联系<span style="color: #4195fb">供给互联官方（如官网客服、微信公众号、官网电话）</span>反馈意见。如反馈意见得以采纳，<span style="color: #f00">供给互联</span>将酌情调整变更事项。
        </p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="17" style="margin-left: 5pt; text-indent: 0pt">
          3.2.2&nbsp;&nbsp;若你在本协议内容公告变更生效后继续使用本服务的，表示你已充分阅读、理解并接受变更后的协议内容，也将遵循变更后的协议内容继续使用<span style="color: #f00">供给互联</span>的服务；若你不同意变更后的协议内容，<span style="color: #f00">供给互联</span>有权停止为你提供本服务。
        </p>
      </div>
      <br />
      <div class="Section1">
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="17" style="margin-left: 5pt; text-indent: 0pt">
          3.2.3&nbsp;你与<span style="color: #f00">供给互联</span>签署的本协议列明的条款并不能完整罗列并覆盖你与<span style="color: #f00">供给互联</span>所有权利与义务，现有的约定也不能保证完全符合未来发展的需求。因此，与<span style="color: #f00">供给互联</span>及你相关的规则均为本协议的补充协议，与本协议不可分割且具有同等法律效力。如你使用<span style="color: #f00">供给互联</span>提供的服务，视为你同意上述补充协议。
        </p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <h1>&nbsp;</h1>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText"><span>四、服务的开通</span>4.1开通条件</p>
        <p class="MsoBodyText">
          4.1.1你可以通过<span><span style="color: #417ff9">管理后台（供给云PC端或供给云APP端）</span></span><span style="color: #f00">开通本服务</span>，具体开通路径为：<span style="color: #417ff9"><span>供给云</span>PC端店铺后台-设置-分销设置，<span>供给云</span>APP端店铺-店铺管理-分销设置。</span>
        </p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText">4.1.2</p>
        <p class="MsoBodyText">
          你理解并同意你需满足入驻条件后方可入驻分佣推广（分销客），<span style="color: #f00">你可以通过“供给云”后台开通路径查询</span><span>你是否满足入驻分佣推广（</span>
          分销客）的条件。
        </p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText">
          4.1.3 你同意<span style="color: #f00">供给互联</span>有权基于产品运营、业务调整、用户体验等原因调整入驻分佣推广（分销客）的条件<span style="color: #417ff9">以及相关规则</span>。
        </p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText">4.2 合作模式</p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText">
          你成功入驻分佣推广（分销客）后，即表明你授权（分销客）无偿使用你的商品信息、商标等推广你店铺的<span style="color: #417ff9">全部商品</span>。
        </p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText">&nbsp;</p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText">五、分佣推广模式</p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText">
          分佣推广模式目前包括通用推广、定向推广两种模式。5.1 通用推广模式
        </p>
        <p class="MsoBodyText">
          通用推广是分佣推广中最基础的计划，若（分销客）推广你店铺的商品达成交易，且该商品或该（分销客）<span>未被设置其他特殊佣金率，则你需按照通用推广设置的类目</span>/店铺佣金率支付佣金。
        </p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText">
          <span style="color: #417ff9">你可以自行设置是否启用（分销客）推广功能。你可以于通用推广中自行设置推广的佣金比例</span><span>，若商品设置了通用单品推广，通用单品推广佣金比例优先级高于通用类目</span>/店铺推广佣金比例。
        </p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText">5.2 定向推广模式</p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText">
          定向推广是商家为特定“分销客”定制的推广计划，你可以通过新建定向推广的方式邀请特定（分销客）帮助你推广商品。你可以在定向推广中设置基础佣金率以及单品推广佣金率，定向单品推广佣金率优先级高于定向基础推广佣金率。
        </p>
        <p class="MsoBodyText">
          你可通过定向推广后台管理你的（分销客），包括你有权决定是否选择让（分销客）加入你的定向推广或清退你定向推广中的（分销客）。定向推广的佣金比例优先级高于通用推广的佣金比例。
        </p>
        <p class="MsoBodyText">
          5.3&nbsp;除另有明确规定外，<span style="color: #f00">佣金设置及佣金比例修改的行为均在次日00：00整生效。</span>
        </p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <h1>&nbsp;</h1>
      </div>
      <br />
      <div class="Section2">
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText" align="justify" style="text-align: justify">
          六、分佣推广的退出
        </p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText" align="justify" style="text-align: justify">
          6.1 你可以通过分佣<b><span>推广后台</span><span>—通用设置</span></b>退出分佣推广，该退出行为<b>次日</b>00<span>：</span><span>0</span>0整<b>生效</b>。
        </p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText" align="justify" style="text-align: justify">
          6.2 你退出分佣推广后，<span style="color: #f00">供给互联</span>有权不保留你的推广数据，当你重新加入分佣推广时，你需重新设置你的佣金率等数据。
        </p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText" align="justify" style="text-align: justify">
          6.3&nbsp;<span style="color: #f00">你退出后次日00：00整起15日内不能再次申请开通/入驻分佣推广。</span>
        </p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText" align="justify" style="text-align: justify">
          6.4
          <span style="color: #f00">你退出分佣推广前已经生效的推广链接依然有效，不因你的退出而失效。此链接成交而产生的佣金，仍应按本协议约定进行结算。</span>
        </p>
        <p class="MsoBodyText" align="justify" style="text-align: justify">
          &nbsp;
        </p>
        <p class="MsoBodyText" align="justify" style="text-align: justify; color: #417ff9">
          6.5
          你退出前已经产生的佣金不因你的退出而失效，你的分销客若在你退出之前存在任意金额的未结算、未提现等佣金，依然可以进行结算和提现。
        </p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <h1 align="justify" style="text-align: justify">&nbsp;</h1>
        <p class="MsoBodyText"><span>七、费用及发票</span>7.1</p>
        <p class="MsoBodyText">
          <span>因运营分佣推广平台需要成本，因此<span style="color: #f00">供给互联</span>将收取佣金总额的</span>10%作为服务费。故（分销客）<span>实际收取的佣金为：佣金总额</span>-“供给云”平台收取的服务费。<span style="color: #417ff9">平台活动期间，会有部分或全部服务费的减免规定，具体金额和比例根据相关活动而定，相关活动以平台公告为准，且解释权归供给互联</span>。
        </p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText">
          7.2&nbsp;你可联系<span style="color: #f00">供给互联</span>人工客服索要发票，申请开具发票的上限金额为“供给云”收取的佣金。（分销客）的税费缴纳及发票由你和（分销客）独立解决，与<span style="color: #f00">供给互联</span>无关。
        </p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText" align="justify" style="text-align: justify">
          7.3
        </p>
        <p class="MsoBodyText" align="justify" style="text-align: justify; color: #f00">
          你同意并授权第三方支付公司（<span style="color: #417ff9">易宝支付</span><span>有限公司，以下简称</span><span>“第三方支付公司”）在你</span>应收到的货款中扣除相应的佣金。
        </p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText" align="justify" style="text-align: justify">
          7.4
        </p>
        <p class="MsoBodyText">
          分佣推广平台的具体数据以“供给云”系统记录的销售数据为准，若因为产品、技术原因或你自身原因导致你少支付佣金的，你承诺并同意将联系<span style="color: #f00">供给互联</span>处理费用归还事宜，并授权“供给云”在你店铺余额中直接扣除相关费用。若由于你的违规操作导致你损失的
        </p>
        <p class="MsoBodyText">
          ，由你自行承担，因此导致<span style="color: #f00">供给互联</span>或第三方损失的，你应当进行赔偿。
        </p>
        <p class="MsoBodyText">7.5 佣金规则</p>
        <p class="MsoBodyText" align="justify" style="text-align: justify">
          7.5.1
          佣金计算基数=商品被成功购买时的消费者实际支付的金额（不含运费）-<span style="color: #419ff9">商家承担的营销费用-第三方支付公司佣金以及其他服务费</span>。
        </p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText" align="justify" style="text-align: justify">
          7.5.2
        </p>
        <p class="MsoBodyText" align="justify" style="text-align: justify">
          <span style="color: #f00">自消费者点击商品推广链接起15天内</span>，消费者成功购买该商品或店铺内其他商品，商家需按照本协议以及设置的佣金比例支付佣金。
        </p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText" align="justify" style="text-align: justify">
          7.5.3
        </p>
        <p class="MsoBodyText" align="justify" style="text-align: justify">
          若消费者在佣金结算前发起退款维权，并且消费者的退款请求得到部分或者全部支持，则佣金按照剩余实付金额（不含运费）占实付总金额（不含运费）的比例进行结算。若消费者在佣金结算后发起退款维权，并且消费者的退款金额得到部分或者全部支持，则佣金不再退回，消费者退款金额的差额由你自行承担。
        </p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText">7.5.4</p>
        <p class="MsoBodyText">
          <span style="color: #f00">供给互联</span><span>相关规则规范约定了一些禁推商品或你的商品未通过审核，但若该商品推广成功，你仍需要按照本协议以及相关规则</span>/规范约定支付佣金。
        </p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText" align="justify" style="text-align: justify">
          7.5.5
          本协议约定的各项费用均按人民币结算，以元为单位，四舍五入保留两位小数点。
        </p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText" align="justify" style="text-align: justify">
          八、双方权利义务
        </p>
      </div>
      <br />
      <div class="Section3">
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText">8.1 商家的权利与义务</p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText">8.1.1</p>
        <p class="MsoBodyText">
          你保证你是依法设立、合法经营的主体，已经取得必要经营资质，有权利和能力签订和履行本协议，你提交的一切资料（包括但不限于注册信息、身份资质、经营资质、授权资质）真实、合法、有效。
        </p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText">
          8.1.2
          你保证你发布的商品信息和推广内容等信息真实、合法、有效，不含以下任一内容：
        </p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText">
          <span>（</span>1）违反国家法律、法规、政策等规定的。
        </p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText"><span>（</span>2）违反公序良俗。</p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText">
          <span>（</span>3）侵犯他人知识产权或其他合法权益的。
        </p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText">
          <span>（</span>4）其他<span style="color: #f00">供给互联</span><span>相关规则</span>/规范规定不得含有/发布的信息。8.1.3
          你商品信息或推广信息中包含的商品，你应确保：
        </p>
        <p class="MsoBodyText"><span>（</span>1）你对商品享有合法权益。</p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText">
          <span>（</span>2）你有合法资质及合法授权推广、销售商品。
        </p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText">
          <span>（</span>3）你的商品符合国家法律法规、行政规章等，符合行业标准及供给互联<span>相关规则</span>/规范。
        </p>
        <p class="MsoBodyText">
          <span>（</span>4）你的商品是国家法律法规、行业标准等允许在网上进行销售的。8.1.4
        </p>
        <p class="MsoBodyText">
          你应保证你有权，并同意授权<span style="color: #f00">供给互联</span>、分销客、第三方平台以及平台用户为促成商品推广使用、编辑你的全部或部分商品信息、推广内容等。
        </p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText">8.1.5</p>
        <p class="MsoBodyText">
          你同意并理解<span style="color: #f00">供给互联</span>、第三方平台以及第三方平台用户有权根据经营需求制定相应的可入驻、可推广等的商家、商品规则及规范，并按照此规则及规范对商家、商品进行审核及管控。
        </p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText">8.1.6</p>
        <p class="MsoBodyText">
          因你操作不当导致的任何损失需由你承担，操作不当包括但不限于未按照说明提示操作、未及时进行操作、泄漏密码、绕开安全程序
        </p>
        <p class="MsoBodyText">、使用恶意计算机程序等。</p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText">
          8.1.7
          你确保不得使用引导购买者退款等任何手段规避佣金的支付。否则，一经发现，<span style="color: #f00">供给互联</span>有权从后续结算款中双倍扣除前述规避的佣金金额。
        </p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText">8.1.8</p>
        <p class="MsoBodyText">
          若由于你的原因（包括但不限于违反法律法规、违反<span style="color: #f00">供给互联</span>相关规则规范、违反本协议等）造成<span style="color: #f00">供给互联</span>、第三方平台、分销客或其他第三方损失的，你应当进行全额赔偿。
        </p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText">
          8.2 <span style="color: #f00">供给互联</span>的权利与义务
        </p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText">8.2.1</p>
        <p class="MsoBodyText">
          <span style="color: #f00">供给互联</span>有权对你提交的资料及商品、素材等进行审核并根据供给云/第三方平台的规则规范等决定是否允许发布于对应的第三方平台或是否允许于第三方平台推广等。该审核仅为形式审核，不代表<span style="color: #f00">供给互联</span>有义务对真实性、合法性等进行任何确认或担保，并且，并不因为<span style="color: #f00">供给互联</span><span>的审核，而减轻你对商品</span>/商品信息等真实性、合法性的保证责任，由此产生的责任和后果仍由你独自承担。该审核仅为<span style="color: #f00">供给互联</span><span>侧审核，</span>
          <span>你理解并同意对应的第三方平台仍有权进行审核。</span>
        </p>
      </div>
      <br />
      <div class="Section4">
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText">8.2.2</p>
        <p class="MsoBodyText">
          <span>若商品</span>/商品信息受到主管机关调查或被第三方（包括但不限于消费者、权利人、第三方平台用户或第三方平台）投诉，或者你存在违反法律法规或违反本协议约定的情况的，<span style="color: #f00">供给互联</span>有权根据一般人的认识自行独立判断，以认定你是否存在违反法律法规或违反本协议或侵犯他人权益的情况，若<span style="color: #f00">供给互联</span>经判断认定你存在违法违规或违反本协议约定情况或侵犯他人合法权益的，<span style="color: #f00">供给互联</span>有权采取以下一项或多项措施：
        </p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText">
          <span>（</span>1）对你的不当行为向消费者进行预警。
        </p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText"><span>（</span>2）屏蔽或删除商品/商品信息。</p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText">
          <span>（</span>3）延长争议订单的结算周期。对你的店铺的账户余额采取部分/全部冻结的措施。
        </p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText"><span>（</span>4）采取限制提现及转账措施。</p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText"><span>（</span>5）对争议订单强制退款。</p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText"><span>（</span>6）限制你使用本服务。</p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText">
          <span>（</span>7）限制你参加<span style="color: #f00">供给互联</span>各平台的活动。
        </p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText">
          <span>（</span>8）在我司官网、商家社区、供给互联公众号等渠道对你的违规行为进行公示。
        </p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText">
          <span>（</span>9）对你采取罚款/违约金，扣除保证金（如有），你同意<span style="color: #f00">供给互联</span>有权指令供给云支付于你的店铺中扣除前述费用，相关费用可用于赔偿损失和支付合理费用等，包括但不限于赔偿<span style="color: #f00">供给互联</span>、分销客、消费者、第三方平台用户等因你的行为遭受的损失。
        </p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText"><span>（</span>10）关闭店铺。</p>
        <p class="MsoBodyText">&nbsp;</p>
        <p class="MsoBodyText">
          <span>（</span>11）其他依据<span style="color: #f00">供给互联</span>相关规则规范采取的措施。
        </p>
        <p class="MsoBodyText">&nbsp;</p>
        <p class="MsoBodyText">8.2.3</p>
        <p class="MsoBodyText">
          <span style="color: #f00">供给互联</span>依据本协议采取相应措施，不应视为<span style="color: #f00">供给互联</span>违约。<span style="color: #f00">供给互联</span>对你采取措施所引起的纠纷、责任等一概由你自行负责，若因此给你造成损失（包括但不限于相关数据清空、消费者未将商品邮回）的，你应自行承担；造成<span style="color: #f00">供给互联</span>或第三方损失的，你应独立承担赔偿责任。如<span style="color: #f00">供给互联代为偿付的，</span><span style="color: #f00">供给互联有权向你全部追偿</span>。
        </p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText">8.2.4</p>
        <p class="MsoBodyText">
          若你的商品或商品信息、资质等受到主管部门调查或第三方投诉，<span style="color: #f00">你应在2个自然日内妥善处理，</span>否则，<span style="color: #f00">供给互联</span>有权在按照本协议约定采取措施的同时，为维护相关方合法权益，有权自主决定先行垫付费用用于处理纠纷及赔偿损失，相关费用<span style="color: #f00">供给互联</span>在你的店铺余额中直接扣除，或另行向你追偿。
        </p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText">8.2.5</p>
        <p class="MsoBodyText">
          如你受到主管部门调查或被第三方投诉，或你投诉第三方，<span style="color: #f00">供给互联</span>有权将争议中相关方的主体资料、联系方式、投诉相关内容等必要信息（包括但不限于名称、电话、证照等）依主管部门或司法机关要求提供给相关方或主管部门，以便及时解决投诉纠纷，保护各方合法权益。
        </p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <p class="MsoBodyText">8.2.6</p>
        <p class="MsoBodyText">
          你确认你通过分佣推广产生的订单数据，你、分销客、<span style="color: #f00">供给互联</span>及第三方推广平台均有权使用，但该使用不得侵犯任何第三方的权利及违反法律法规的要求。
        </p>
        <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
        <h1>&nbsp;</h1>
        <p class="MsoBodyText"><span>九、协议的解除和终止</span>9.1</p>
        <p class="MsoBodyText">
          除本协议另有规定外，如你违反其在本协议项下的义务、承诺、陈述或保证等规定，供给互联有权根据情况要求你在一定期限内予以更正
        </p>
        <p class="MsoBodyText">
          ；你未能在规定的期限内按照<span style="color: #f00">供给互联</span>的要求予以更正的，<span style="color: #f00">供给互联</span>有权立即解除本协议。
        </p>
      </div>
      <br />
      <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
      <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
      <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
      <p class="MsoBodyText">9.2 满足以下任一情形，本协议自动终止：</p>
      <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
      <p class="MsoBodyText">
        <span>（</span>1）因不可抗力影响，使协议无法履行，则协议自动终止，无须承担违约责任；
      </p>
      <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
      <p class="MsoBodyText">
        <span>（</span>2）你存在违反本协议，或违反供给互联发布的通知、公告、规则，或违反法律法规的行为，且此类行为恶劣或影响严重<span style="color: #f00">供给互联</span>认为需自动解除本协议的；
      </p>
      <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
      <p class="MsoBodyText">
        （3）<span style="color: #f00">供给互联</span>基于业务需求，停止提供服务的。
      </p>
      <p class="MsoBodyText">
        （4）<span style="color: #419ff9">你因不具备相关资质，或者经查资质失效或者存在造假情况的。</span>
      </p>
      <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
      <p class="MsoBodyText">
        9.3
        本协议的提前终止不影响双方于本协议提前终止日之前，根据本协议已产生的权利和义务的履行。
      </p>
      <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
      <p class="MsoBodyText">
        9.4除非<span style="color: #f00">供给互联</span>与你另有明确约定，<span style="color: #f00">供给互联</span>有权在<span>提前</span>3天通知你后，单方面终止本协议，且无需承担违约金责任。
      </p>
      <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
      <h1>&nbsp;</h1>
      <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
      <p class="MsoBodyText">十、免责条款</p>
      <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
      <p class="MsoBodyText">
        10.1&nbsp;你充分理解推广可能因电信部门调整、政府管制、电信运营商暂停服务或发生故障及网络媒体经营调整等<span style="color: #f00">供给互联</span>控制之外的因素造成的延误，<span style="color: #f00">供给互联</span>对此免责。
      </p>
      <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
      <p class="MsoBodyText">
        10.2 你理解并同意，<span style="color: #f00">供给互联</span>有权依法在“供给云”服务器上保存你的信息（包括但不限于你选择的发布信息、分佣金额等）。
      </p>
      <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
      <p class="17" style="margin-left: 23.05pt; text-indent: -18.05pt">
        10.3&nbsp;&nbsp;你确认并同意，<span style="color: #f00">供给互联</span>不对你使用<span style="color: #f00">供给互联</span>本服务可获得的网络推广信息的访问量、经营业绩等作任何明示或暗示的承诺。
      </p>
      <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
      <p class="17" style="margin-left: 23.05pt; text-indent: -18.05pt">
        10.4&nbsp;&nbsp;<span style="color: #f00">供给互联</span><span>将按</span><span>“现状”和“可得到”的状态向你提供本服务。</span>
      </p>
      <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
      <p class="17" style="margin-left: 23.05pt; text-indent: -18.05pt">
        10.5&nbsp;&nbsp;针对第三方（包括分销客、第三方平台及用户等）原因造成你损失的，<span style="color: #f00">供给互联</span>不承担任何责任。
      </p>
      <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
      <h1>&nbsp;</h1>
      <p class="MsoBodyText">十一、法律的适用、管辖与其他</p>
      <p class="MsoBodyText">&nbsp;</p>
      <p class="MsoBodyText">
        11.1
        &nbsp;&nbsp;本协议之效力、解释、变更、执行与争议解决均适用中华人民共和国法律，没有相关法律规定的，参照通用国际商业惯例和（或）行业惯例。
      </p>
      <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
      <p class="MsoBodyText">
        11.2&nbsp;因本协议所产生的争议，由<span style="color: #f00">供给互联</span>与你共同协商解决。协商不成时，任何一方均可向协议签订地的人民法院提起诉讼，本协议的签订地为<u style="color:#f00"><span style="color:#f00">北京丰台区新发地国际名酒城5号楼1单元202室</span></u>。
      </p>
      <p class="MsoBodyText" style="margin-left: 0pt">&nbsp;</p>
      <p class="MsoBodyText">
        11.3
        &nbsp;如本协议的任何条款被视作无效或无法执行，则上述条款可被分离，其余条款则仍具有法律效力。
      </p>
      <p class="MsoBodyText" style="margin-left: 5pt">&nbsp;</p>
      <p class="MsoBodyText">
        11.4
        &nbsp;本协议任何一方于另一方过失或违约时放弃本协议规定的权利的，不得视为其对一方的其他或以后同类之过失或违约行为弃权。<span style="color: #f00">供给互联</span>未行使或执行本协议任何权利或规定，不构成对前述权利或权利放弃。
      </p>
    </div>
  </div>
</template>

<style lang="less">
.app-agreement {
  min-height: 100vh;
  font-size: 1.4rem;
  white-space: normal;
  .content {
    width: 98%;
    margin: 0 auto;
    .txt-center {
      text-align: center;
      font-size: 1.5rem;
    }
  }
}
</style>